import { z } from "zod";

import { roundValuePrecisionSchema } from "./enums";

export const roundValueConfigurationSchema = z.object({
	sourceField: z.string(),
	precision: roundValuePrecisionSchema,
});
